import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import { Row } from "components/styles";

const FilterFields = ({
    filters
}) => {
    //#region States
    const { studentId, penaltyStartDate } = filters.value;
    //#endregion
    //#region Functions
    const changeStudentIdField = value => {
        filters.change("studentId", value);
    }
    const changePenaltyStartDate = value => {
        filters.change("penaltyStartDate", value);
    }
    //#endregion
    return (
        <Row>
            <CustomTextInput 
                label="Buscador"
                placeholder="Escribe el código del alumno"
                value={studentId}
                onChange={changeStudentIdField}/>
            <CustomDatePicker 
                label="Inicio de sanción"
                placeholder="Elige una fecha"
                value={penaltyStartDate}
                onChange={changePenaltyStartDate}
                period={{
                    min: [2022, 0, 1],
                    max: [3000, 0, 1]
                }}/>
        </Row>
    );
}

export default FilterFields;